<template>
  <b-container>
    <h1 v-translate>Company Area</h1>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <company-navigation />
      </div>
      <div class="col-md-9 personal-info">
        <b-row>
          <b-col cols="12" class="mb-4">
            <h3>
              <translate>Company Users Management</translate>
              <b-button size="sm" variant="success"  v-b-modal.modalNewUser>
                <font-awesome-icon icon="user-plus" size="1x" /> <translate>New User</translate>
              </b-button>
            </h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" lg="4" v-for="(user, index) in users" :key="index">
            <b-card class="text-center" :class="!user.active ? 'text-muted': ''">
              <small v-show="user.roles.findIndex(y => y.name === 'company-admin') !== -1" class="bg-dark text-light" style="position:absolute; top: 0; left: 0; padding:3px;"><font-awesome-icon icon="user-cog" size="1x" /> ADMIN</small>
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="mb-3 rounded-circle profile-image" alt="img" :style="'width: 80px; height: 80px; background-image: url(' + (user.profile_picture || 'https://www.gravatar.com/avatar/default?s=80&r=pg&d=mm') + ')'" />
              <b-card-title class="mb-2">{{user.name}}</b-card-title>
              <b-card-text>
                <div class="mb-3">{{user.email}}</div>
                <b-button size="sm" variant="link" class="text-danger" @click="deleteUser(user)" :disabled="(oneAdminOnly && user.roles.findIndex(y => y.name === 'company-admin') !== -1)" v-b-tooltip.hover :title="$gettext('Delete User')">
                  <font-awesome-icon icon="trash-alt" size="2x" />
                </b-button>
                <b-button size="sm" variant="link" class="text-dark" @click="setUserAsAdmin(user)" v-show="user.active && user.roles.findIndex(y => y.name === 'company-admin') === -1" v-b-tooltip.hover :title="$gettext('Set As Admin User')">
                  <font-awesome-icon icon="user-cog" size="2x" />
                </b-button>
                <b-button size="sm" variant="link" :disabled="oneAdminOnly" @click="setUserAsNormal(user)" v-show="user.active && user.roles.findIndex(y => y.name === 'company-admin') !== -1" v-b-tooltip.hover :title="$gettext('Set As Normal User')">
                  <font-awesome-icon icon="user" size="2x" />
                </b-button>
              </b-card-text>
              <div slot="footer">
                <b-form-checkbox class="save-from mb-0"
                  v-model="user.active"
                  :value="1"
                  :unchecked-value="0"
                  @change="enableDisableUser(index)">
                  <span v-translate>Unactive</span> <span class="switch"><span class="slider round"></span></span> <span v-translate>Active</span>
                </b-form-checkbox>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <div class="d-none">
          <translate>Delete User</translate>
          <translate>Set As Admin User</translate>
          <translate>Set As Normal User</translate>
        </div>

        <b-modal size="md" id="modalNewUser" ref="modalNewUser" :hide-footer="true"  @hide="newUser = {}">
          <div slot="modal-title" v-translate>Create New Company User</div>
          <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
          <form @submit.stop.prevent="createUser">
            <div class="form-group col-sm-12">
              <label for="from_contact" v-translate>Name</label>
              <div class="input-group">
                <b-form-input id="from_contact" name="from_contact" v-model="newUser.name" required />
              </div>
            </div>
            <div class="form-group col-sm-12">
              <label for="from_email" v-translate>E-mail</label>
              <div class="input-group">
                <b-form-input trim id="from_email" name="from_email" v-model="newUser.email" required />
              </div>
            </div>
            <div class="text-right form-group col-12 form-actions">
              <b-button type="submit" variant="primary" size="lg" v-translate>Create User</b-button>
              <b-button type="button" variant="outline-primary" size="lg" @click.prevent="$refs.modalNewUser.hide()" v-translate>Cancel</b-button>
            </div>
          </form>
        </b-modal>
      </div>
    </div>
  </b-container>
</template>

<script>
import { FETCH_PROFILE } from '@/store/actions.type'
import CompanyNavigation from '@/components/CompanyNavigation'

export default {
  title() {
    return this.$gettext('Users Management')
  },
  components: {
    CompanyNavigation
  },
  data() {
    return {
      users: [],
      newUser: {},
      companyAdminRole: {}
    }
  },
  computed: {
    oneAdminOnly() {
      return this.users.filter(x => x.roles.findIndex(y => y.name === 'company-admin') !== -1).length === 1
    },
    hasCompany() {
      return this.$store.getters.profile && this.$store.getters.profile.company_id !== null
    },
    isCompanyAdmin() {
      return this.hasCompany && this.$store.getters.profile.company && this.$store.getters.profile.roles.findIndex(x => x.name === 'company-admin') !== -1
    }
  },
  created() {
    this.fetchCompanyAdminRole()
  },
  mounted() {
    this.fetchUsers()
  },
  methods: {
    fetchCompanyAdminRole() {
      const params = {
        filter_groups: [{
          filters: [
            ['name', 'eq', 'company-admin']
          ]
        }]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'roles', { params })
        .then(response => {
          this.companyAdminRole = response.body.data
        })
    },
    fetchUsers() {
      this.$store.dispatch(FETCH_PROFILE)
        .then(response => {
          this.users = response.company.users
          this.newUser.company_id = response.company.id
        })
    },
    disableUser(user) {
      this.$http.delete(this.$appConfig.api.baseUrl + 'companies/users/' + user.id + '/disable')
        .then(response => {
          this.fetchUsers()
        })
    },
    enableUser(user) {
      this.$http.put(this.$appConfig.api.baseUrl + 'companies/users/' + user.id + '/enable')
        .then(response => {
          this.fetchUsers()
        })
    },
    enableDisableUser(index) {
      this.$nextTick(() => {
        const user = this.users[index]
        if (user.active === 0) {
          this.disableUser(user)
        } else {
          this.enableUser(user)
        }
      })
    },
    deleteUser(user) {
      const translate = this.$gettext('Are you sure you want to DELETE the user %{userName}? Please be careful, this action CANNOT be undone.')
      if (confirm(this.$gettextInterpolate(translate, { userName: user.name })) === true) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'companies/users/' + user.id + '/disable?level=hard')
          .then(response => {
            this.fetchUsers()
          })
      }
    },
    setUserAsNormal(user) {
      if (this.companyAdminRole[0].id) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'companies/users/' + user.id + '/roles', { body: [this.companyAdminRole[0].id] })
          .then(response => {
            this.fetchUsers()
          })
      }
    },
    setUserAsAdmin(user) {
      if (this.companyAdminRole[0].id) {
        this.$http.post(this.$appConfig.api.baseUrl + 'companies/users/' + user.id + '/roles', [this.companyAdminRole[0].id])
          .then(response => {
            this.fetchUsers()
          })
      }
    },
    createUser(user) {
      this.newUser.country_iso_code = this.$cookies.get('country')
      this.$http.post(this.$appConfig.api.baseUrl + 'companies/users', this.newUser)
        .then(response => {
          this.newUser = {}
          this.fetchUsers()
          this.$refs.modalNewUser.hide()
        }, error => {
          if (error.status === 409) {
            const obj = {
              title: 'ERROR',
              message: this.$gettextInterpolate(this.$gettext('<p>The user already exists into our system.</p><p>Please, contact <a href="mailto:%{salesEmail}">%{salesEmail}</a> to get them added to your company.</p>'), { salesEmail: this.salesEmail }),
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          }
        })
    }
  }
}
</script>
